export enum MessageReturnError {
    Validation = 'Validation',
    Operation = 'Operation',
}

interface ErrorInfo {
    name?: string | null
    message: string
    isHttpError: boolean
    arg?: any
}

const errorMessages = (
    err: any,
    customDefaultErrorMessage?: string,
): ErrorInfo => {
    if (typeof err === 'string')
        return { message: err || 'common.error.unknown', isHttpError: false }

    let message = ''
    let arg: any = {}
    let isHttpError = false

    if (err && err.response) {
        if (
            err.response.data.errorType === MessageReturnError.Validation ||
            err.response.data.errorType === MessageReturnError.Operation
        ) {
            message = err.response.data.message
            arg = err.response.data.additionValue || {}
            isHttpError = true
        }
    } else if (err && err.message) {
        message = err.message
        arg = err.arg || err.additionValue || {}
    }
    // ... Handle other message type...

    return {
        name: err?.name,
        message: message || customDefaultErrorMessage || 'common.error.unknown',
        arg,
        isHttpError,
    }
}

export default errorMessages
